// Pricing toggle controller for switching between monthly and annual plans
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["monthlyPlans", "annualPlans", "monthlyButton", "annualButton"]

  connect() {
    // Check URL params or default to monthly
    const urlParams = new URLSearchParams(window.location.search)
    const interval = urlParams.get("interval") || "month"
    this.switchInterval(interval)
  }

  switchToMonthly(event) {
    event.preventDefault()
    this.switchInterval("month")
    this.updateURL("month")
  }

  switchToAnnual(event) {
    event.preventDefault()
    this.switchInterval("year")
    this.updateURL("year")
  }

  switchInterval(interval) {
    if (interval === "year") {
      this.monthlyPlansTargets.forEach(target => target.classList.add("hidden"))
      this.annualPlansTargets.forEach(target => target.classList.remove("hidden"))
      this.monthlyButtonTargets.forEach(btn => {
        btn.classList.remove("bg-indigo-600", "text-white")
        btn.classList.add("bg-gray-700", "text-gray-300")
      })
      this.annualButtonTargets.forEach(btn => {
        btn.classList.add("bg-indigo-600", "text-white")
        btn.classList.remove("bg-gray-700", "text-gray-300")
      })
    } else {
      this.monthlyPlansTargets.forEach(target => target.classList.remove("hidden"))
      this.annualPlansTargets.forEach(target => target.classList.add("hidden"))
      this.monthlyButtonTargets.forEach(btn => {
        btn.classList.add("bg-indigo-600", "text-white")
        btn.classList.remove("bg-gray-700", "text-gray-300")
      })
      this.annualButtonTargets.forEach(btn => {
        btn.classList.remove("bg-indigo-600", "text-white")
        btn.classList.add("bg-gray-700", "text-gray-300")
      })
    }
  }

  updateURL(interval) {
    const url = new URL(window.location)
    url.searchParams.set("interval", interval)
    window.history.pushState({}, "", url)
  }
}

